import React from 'react';
import { Button } from 'antd';
import { DiffOutlined, ExportOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import DeclarationDiff from '../DeclarationDiff';
import ChangeLogPanel from './ChangeLogPanel';
import ChangeDetailBar from './ChangeDetailBar';

/**
 * Consumer detail panel: read-only. Log first (it explains what happened),
 * then the declaration diff across the full width of the entry.
 */
const ConsumerChangeDetail = ({ record, extraProps }: { record: Record<string, any>; extraProps?: any }) => (
    <div className="ci-detail">
        <ChangeDetailBar record={record} resource={extraProps?.resource}>
            {record.submission?.id && (
                <Link to={`/submissions/${record.submission.id}/`}>
                    <Button icon={<ExportOutlined />}>Submission page</Button>
                </Link>
            )}
        </ChangeDetailBar>

        <ChangeLogPanel log={record.log} />

        <section className="ci-block">
            <header className="ci-block__head">
                <DiffOutlined className="ci-block__icon" aria-hidden="true" />
                <h4 className="ci-block__title">Declaration diff</h4>
            </header>
            <div className="ci-diff">
                <DeclarationDiff change_instance={record} />
            </div>
        </section>
    </div>
);

export default ConsumerChangeDetail;
